import { render } from "./NavbarMenus.vue?vue&type=template&id=15a7e1a0"
import script from "./NavbarMenus.vue?vue&type=script&lang=js"
export * from "./NavbarMenus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__